import { IInfrastructure } from '../utils';

interface IToGeoObjectsProps {
  infrastructureByYear: Map<number, IInfrastructure>;
  year: number;
}

export const toGeoObjects = ({ infrastructureByYear, year }: IToGeoObjectsProps) => {
  const geoObjectsData = infrastructureByYear.get(year)?.geoObjectsData || [];

  return geoObjectsData.map(datum => datum.geoObject);
};
